import {PlusOutlined} from "@ant-design/icons";
import {Button} from "antd";
import React from "react";
import {useNavigate} from "react-router-dom";
import {CaseListingExcelDownload} from "../CaseListingExcelDownload";
import {useDispatch} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";

const CaseListingHeader = ({tableFilters}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleExcelDownload = () => {
        dispatch(SET_IS_API_CALLED("Downloading Excel Data"));
        CaseListingExcelDownload({
            dateFrom: tableFilters?.dateFrom ?? null,
            dateTo: tableFilters?.dateTo ?? null
        }).finally(() => {
            dispatch(SET_IS_API_CALLED_FINISHED());
        });
    }

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <p className="font-bold text-xl">List of Cases</p>
                </div>
                <div className="flex gap-3 justify-between items-center">
                    <img
                        src={"/assets/icon-excel.svg"}
                        className=" cursor-pointer"
                        onClick={handleExcelDownload}
                        width={30}
                        height={30}
                        alt=""
                    />
                    <Button
                        className="bg-medium-blue-100 text-white"
                        onClick={() => navigate("/wf-create-case")}
                        icon={<PlusOutlined/>}
                    >
                        Create Case
                    </Button>
                </div>
            </div>
        </>
    );
};

export default CaseListingHeader;
